module.exports = __webpack_public_path__ + "static/mare_high-8bf5b60dd14f8ffe546e7fecfd921619.mp4";